import { Box, useCircleSize, useSpaceSize } from "arkh";
import React from "react";
import { useFragment, graphql } from "react-relay";

import { TodoTimelineUpdateEvent } from "./TodoTimelineUpdateEvent";

import { TodoTimeline_item$key } from "./__generated__/TodoTimeline_item.graphql";
import { TodoTimelineUpdate_todoTimelineUpdate$key } from "./__generated__/TodoTimelineUpdate_todoTimelineUpdate.graphql";
import { TodoTimelineComment } from "./TodoTimelineComment";
import { TodoTimelineFeedback } from "./TodoTimelineFeedback";
export { TodoTimelineCreatedEvent } from "./TodoTimelineUpdateEvent";
export function TodoTimelineItem(props: {
  item: TodoTimeline_item$key;
  commentHeaderRight?: React.ReactNode;
}) {
  const item = useFragment(
    graphql`
      fragment TodoTimeline_item on TodoTimelineItem {
        ... on TodoComment {
          ...TodoTimelineComment_todoComment
          __typename
        }
        ... on TodoTimelineUpdate {
          __typename

          ...TodoTimelineUpdate_todoTimelineUpdate
        }
        ... on TodoFeedback {
          __typename
          ...TodoTimelineFeedback_feedback
        }
      }
    `,
    props.item
  );

  switch (item.__typename) {
    case "TodoComment":
      return (
        <TodoTimelineComment
          comment={item}
          commentHeaderRight={props.commentHeaderRight}
        />
      );
    case "TodoTimelineUpdate":
      return <TodoEditNewMainTimelineUpdate item={item} />;
    case "TodoFeedback":
      return <TodoTimelineFeedback feedback={item} />;
  }
}

function TodoEditNewMainTimelineUpdate(props: {
  item: TodoTimelineUpdate_todoTimelineUpdate$key;
}) {
  const data = useFragment(
    graphql`
      fragment TodoTimelineUpdate_todoTimelineUpdate on TodoTimelineUpdate {
        events {
          __typename

          ...TodoTimelineUpdateEvent_event
        }
        ...TodoTimelineUpdateEvent_timelineItem
      }
    `,
    props.item
  );
  return data.events.map((event, i) => (
    <TodoTimelineUpdateEvent
      key={i + event.__typename + ""}
      event={event}
      timelineItem={data}
    />
  ));
}

export function TodoTimelineVerticalLine() {
  const circelSize = useCircleSize("smallMedium");
  const smallSize = useSpaceSize("small");
  const left = smallSize + circelSize / 2;
  return (
    <Box
      style={{
        flex: 1,
        position: "absolute",
        left: left,
        right: 0,
        height: "100%",
      }}
    >
      <Box
        color="border-primary"
        style={{
          height: "100%",
          width: 1,
          flex: 1,
        }}
      />
    </Box>
  );
}
